/* ===========================================================================
  Foundation
  =========================================================================== */

// Require
import Vue, {configureCompat} from 'vue';
import 'whatwg-fetch';
import $ from 'jquery';
import 'jquery.cookie';
import 'jquery-ui/dist/jquery-ui';
import 'jquery-ui/ui/widgets/sortable';
import 'foundation-sites/js/foundation.core.js';
import 'foundation-sites/js/foundation.abide.js';
import 'foundation-sites/js/foundation.accordion.js';
import 'foundation-sites/js/foundation.reveal.js';
import 'foundation-sites/js/foundation.offcanvas.js';
import 'foundation-sites/js/foundation.magellan.js';
import 'foundation-sites/js/foundation.tabs.js';
import 'foundation-sites/js/foundation.toggler.js';
import 'foundation-sites/js/foundation.dropdown.js';
import 'foundation-sites/js/foundation.sticky.js';
import 'foundation-sites/js/foundation.drilldown';
import 'foundation-sites/js/foundation.slider';
import 'foundation-sites/js/foundation.util.keyboard.js';
import 'foundation-sites/js/foundation.util.nest';
import 'foundation-sites/js/foundation.util.box.js';
import 'foundation-sites/js/foundation.util.timerAndImageLoader.js';
import 'foundation-sites/js/foundation.util.mediaQuery.js';
import 'foundation-sites/js/foundation.util.triggers.js';
import 'foundation-sites/js/foundation.util.motion.js';
import 'foundation-sites/js/foundation.util.touch';
import 'select2/dist/js/select2.js';
import 'lightbox2/dist/js/lightbox.js';
import 'select2/dist/js/i18n/fr.js';
import {initAjaxCallbackMessage} from './components/ajaxCallback';
import './components/polyfill';
import './components/moving';
import './components/grid';
import {$aside, activeClass, srollingClass} from './settings/settings';
import {modalAjax} from './components/modal';
import {offCanvasFixed} from './components/offcanvas';
import {clearInput, removePreviewFile, showPreviewFile} from './components/upload';
import {
    $buttonStepNext,
    $stepCounter,
    $stepCounterEdit,
    checkStepValidation,
    goToNextStep,
    initStepMagellan,
    initStepSticky,
    openNextStep,
} from './components/step';
import './components/seller';
import './components/carousel';
import './components/select';
import './components/password';
import './components/share';
import './components/bankroll';
import './components/conversation';
import './components/navigation';
import './components/readMore';
import './components/accordion';
import './components/dropdown';
import './components/filter';
import './components/dragSortPlugin';
import './components/dragAndDrop';
import './components/listing';
import './components/toggleBlock';
import './components/popin';
import './components/popinV2';
import './components/currency';
import './components/storeMap';
import {topBanner} from './components/topBanner';
import {sticky} from './components/sticky';
import {initFilterSellForm} from './components/newItem';
import initBrowserClass from './components/browserClass';
import {movingItemSelectDeliveryPoint, searchPointRelais} from './components/item';

import '../scss/app.scss';

require.context('../images/icon', true);

configureCompat({
    MODE: 2,
    COMPONENT_ASYNC: false,
});

window.$ = $;

// Default configuration
Foundation.Reveal.defaults.animationIn = 'slide-in-down';
Foundation.Reveal.defaults.animationOut = 'fade-out';
Foundation.OffCanvas.defaults.transition = 'overlap';

document.addEventListener('DOMContentLoaded', () => {
    $(document).foundation();

    $('[data-off-canvas]').each((index, element) => {
        const instance = $(element).data('zfPlugin');
        if (instance.options.overlayClass) {
            instance.$overlay.addClass(instance.options.overlayClass);
        }
    });

    /*
       Toggler
       ===================================== */
    const $toggler = $('[data-toggler]');
    const $faq = $('.faq-list');

    if ($toggler && !$faq) {
        $toggler
            .on('on.zf.toggler', function () {
                $(this)
                    .parent()
                    .removeClass(activeClass);
            })
            .on('off.zf.toggler', function () {
                $(this)
                    .parent()
                    .addClass(activeClass);
            });

        // Close the current target opened
        $('[data-toggle]').on('click', () => {
            const $currentTarget = $(`[data-toggler].${activeClass}`);

            if ($currentTarget) {
                $currentTarget.removeClass(activeClass);
            }
        });
    }

    movingItemSelectDeliveryPoint();
    searchPointRelais();

    /*
       Modal Ajax
       ===================================== */

    $('[data-reveal-ajax]').on('click', function (e) {
        e.preventDefault();

        // Run Foundation modalAjax
        modalAjax($(this).attr('href'));
    });

    $('[data-abide]').on('forminvalid.zf.abide', (event) => {
        event.preventDefault();
        const $error = $('.is-invalid-input:first');
        const headerHeight = $('#js-header').height();
        const scrollTop = $error.offset().top - headerHeight - 50;

        // Setting password regex pattern
        Foundation.Abide.defaults.patterns['password'] = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).(?=.*?[!@#$%^&*+`~'=?\|\]\[\(\)\-<>/]).{11,}/;

        if ($error) {
            $('html, body').animate({scrollTop}, 500);
        }

        return false;
    });

    /*
       Item
       ===================================== */

    const $itemTabsDescription = $('#js-item-tabs-description');

    if ($itemTabsDescription.length && !Foundation.MediaQuery.atLeast('large')) {
        const $itemDetailTabs = new Foundation.Tabs($itemTabsDescription);
    }

    /*
    function itemExchangeInfosTabs() {

      const $itemExchangeInfos = $("#js-item-exchange-infos");

      if ($itemExchangeInfos.length && Foundation.MediaQuery.current === "small" || $itemExchangeInfos.length && Foundation.MediaQuery.current === "medium") {
        const $itemExchangeTabs = new Foundation.Tabs($itemExchangeInfos);
      } else if ($itemExchangeInfos.length && $itemExchangeInfos.attr('role') && Foundation.MediaQuery.current === "large" || $itemExchangeInfos.length && $itemExchangeInfos.attr('role') && Foundation.MediaQuery.current === "xlarge") {
        $itemExchangeInfos.foundation('destroy');
        $('.item-exchange-content .tabs-panel').attr('aria-hidden', 'false');
      }

    }
    */

    // itemExchangeInfosTabs();

    function bankrollTabs() {

        const $bankroll = $('#js-bankroll');

        if ($bankroll.length) {
            const $bankrollTabs = new Foundation.Tabs($bankroll);
        }

    }

    bankrollTabs();

    /*
     Step
     ===================================== */
    if ($('.js-gender').length) {
        initFilterSellForm();
    }

    if ($stepCounter.length) {
        const $name = document.querySelector('.js-vue-name');
        const $description = document.querySelector('.js-vue-description');
        const $price = document.querySelector('.js-vue-price');
        const $sizeList = document.querySelector('.js-vue-size');
        const $brandList = document.querySelector('.js-vue-brand');
        const $conditionList = document.querySelectorAll('.js-vue-condition');

        const $condition = $('#js-condition');
        const $size = $('#js-size');
        const $brand = $('#js-brand');

        const getSizeValue = () => {
            const value = $sizeList.options[$sizeList.options.selectedIndex].text;
            return $size.html(value);
        };

        const getBrandValue = () => {
            const value = $brandList.options[$brandList.options.selectedIndex].text;
            return $brand.html(value);
        };

        const getConditionValue = () => {
            const itemSelected = [...$conditionList].filter((item) => item.checked);
            const value = itemSelected.length > 0 ? itemSelected[0].parentNode.querySelector('h3').textContent : null;

            return $condition.html(value);
        };

        new Vue({
            delimiters: ['${', '}'],
            el: '#js-step-list',
            data: () => ({
                name: $name ? $name.value : '',
                description: $description ? $description.value : '',
                price: $price.value ? $price.value : '0',
                size: $size ? getSizeValue() : '',
                brand: $brand ? getBrandValue() : '',
                condition: $condition ? getConditionValue() : '',
                shop: '',
            }),
            mounted: function () {
                const $itemSaleDeposit = $('#js-item-sale-deposit');
                const $delivery = $('#js-delivery');
                const $remuneration = $('#js-remuneration');
                const $deliveryCheckbox = $('.js-vue-delivery');
                const $selectRange = $('.js-select2-range');
                const $selectCategory = $('.js-select2-category');
                const $selectGender = $('.js-select2-gender');
                const $selectColor = $('.js-select2-color');

                $itemSaleDeposit.select2({
                    language: 'fr',
                    maximumSelectionLength: 3,
                });

                $('.js-select2-shop').select2({
                    language: 'fr',
                    maximumSelectionLength: '3',
                });

                $selectColor.select2({
                    language: 'fr',
                    maximumSelectionLength: '3',
                    placeholder: 'Sélectionnez une couleur',
                    matcher: matchStart,
                });

                $('.js-select2-material').select2({
                    language: 'fr',
                    maximumSelectionLength: '2',
                    placeholder: 'Sélectionnez une matière',
                });

                $('.js-select2-brand').select2({
                    language: 'fr',
                    matcher: brandMatcher,
                });

                $selectGender.select2({language: 'fr'});
                $('.js-select2-heelType').select2({language: 'fr'});
                $('.js-select2-heelHeight').select2({language: 'fr'});
                $('.js-select2-typeShape').select2({language: 'fr'});
                $('.js-select2-closing').select2({language: 'fr'});
                $('.js-select2-calfWidth').select2({language: 'fr'});
                $('.js-select2-pattern').select2({language: 'fr'});
                $selectCategory.select2({language: 'fr'});
                $selectRange.select2({language: 'fr'});
                $('.js-select2-size').select2({language: 'fr'});

                $selectRange.on('change', function (e) {
                    const $this = e.target;
                    const $range = $('#js-range');
                    if ($this) {
                        const value = $this.options[$this.selectedIndex].text;
                        return $range.text(value + ' - ');
                    }
                });
                if ($selectRange.val()) {
                    $('#js-range').text($selectRange[0].options[$selectRange[0].selectedIndex].text + ' - ');
                }

                $selectCategory.on('change', function (e) {
                    const $this = e.target;
                    const $category = $('#js-category');
                    if ($this) {
                        const value = $this.options[$this.selectedIndex].text;
                        return $category.html(value);
                    }
                });
                if ($selectCategory.val()) {
                    $('#js-category').text($selectCategory[0].options[$selectCategory[0].selectedIndex].text);
                }

                $selectGender.on('change', function (e) {
                    const $this = e.target;
                    const $gender = $('#js-gender');
                    if ($this) {
                        const value = $this.options[$this.selectedIndex].text;
                        return $gender.text(value + ' - ');
                    }
                });
                if ($selectGender.val()) {
                    $('#js-gender').text($selectGender[0].options[$selectGender[0].selectedIndex].text + ' - ');
                }

                $selectColor.on('change', function (e) {
                    const $this = e.target;
                    const $color = $('#js-color');

                    if ($this) {
                        const $selectedIndexes = $($this).val();
                        const colors = $selectedIndexes.map(selectedIndex => {
                            return $this.options[selectedIndex].text;
                        });
                        return $color.text(colors.join(' - '));
                    }
                });
                if ($selectColor.val()) {
                    $('#js-color').text($selectColor.val().map(index => $selectColor[0].options[index].text).join(' - '));
                }

                $itemSaleDeposit.on('change', function (e) {
                    const selected = $(this).find('option:selected');
                    const $shops = [...selected];
                    const shopValue = [];

                    $shops.forEach(function (shop) {
                        shopValue.push(shop.innerText);
                    });

                    document.getElementById('js-shops').innerHTML = shopValue.join(
                        '<br>',
                    );
                });

                $itemSaleDeposit.trigger('change');

                $deliveryCheckbox.on('click', function () {
                    if (this.checked) {
                        this.setAttribute('checked', 'checked');
                    } else {
                        this.removeAttribute('checked');
                    }
                });

                $('#delivery .js-step-next, #remuneration .js-step-next').on('click', function () {
                    $delivery.html('');
                    $remuneration.html('');

                    const newDeliveryMethodShop2Shop = $('#p2s_new_item_deliveryMethod_0');
                    const editDeliveryMethodShop2Shop = $('#p2s_edit_item_deliveryMethod_0');
                    const newDeliveryMethodShopWithdrawal = $('#p2s_new_item_deliveryMethod_1');
                    const editDeliveryMethodShopWithdrawal = $('#p2s_edit_item_deliveryMethod_1');

                    // For new item
                    if (newDeliveryMethodShop2Shop.attr('checked') != undefined && newDeliveryMethodShopWithdrawal.attr('checked') != undefined) {
                        $delivery.append(newDeliveryMethodShop2Shop.next('label').html() + '<br />' + newDeliveryMethodShopWithdrawal.next('label').html());
                    } else if (newDeliveryMethodShop2Shop.attr('checked') != undefined) {
                        $delivery.append(newDeliveryMethodShop2Shop.next('label').html());
                    } else if (newDeliveryMethodShopWithdrawal.attr('checked') != undefined) {
                        $delivery.append(newDeliveryMethodShopWithdrawal.next('label').html());
                    }

                    // For edit item
                    if (editDeliveryMethodShop2Shop.attr('checked') != undefined && editDeliveryMethodShopWithdrawal.attr('checked') != undefined) {
                        $delivery.append(editDeliveryMethodShop2Shop.next('label').html() + '<br />' + editDeliveryMethodShopWithdrawal.next('label').html());
                    } else if (editDeliveryMethodShop2Shop.attr('checked') != undefined) {
                        $delivery.append(editDeliveryMethodShop2Shop.next('label').html());
                    } else if (editDeliveryMethodShopWithdrawal.attr('checked') != undefined) {
                        $delivery.append(editDeliveryMethodShopWithdrawal.next('label').html());
                    }

                    $remuneration.append($('#remuneration .l-dropdown-selected-value').html());
                });

                const editForm = $('form[name=\'p2s_edit_item\']');
                // ---------------------------------------------------------------------
                // ITEM SELECT FIELDS ON EVENT TYPE
                // ---------------------------------------------------------------------
                const genderChoiceType = $('.js-select2-gender');
                const rangeChoiceType = $('.js-select2-range');
                const categoryChoiceType = $('.js-select2-category');
                const sizeChoiceType = $('.js-select2-size');
                const heelTypeSelectBox = $('#heelTypeSelectBox');
                const heelHeightSelectBox = $('#heelHeightSelectBox');
                const closingSelectBox = $('#closingSelectBox');
                const typeShapeSelectBox = $('#typeShapeSelectBox');
                const calfWidthSelectBox = $('#calfWidthSelectBox');
                const ceremonyCheckBoxType = $('.js-checkbox-ceremony');

                const rangeChoiceTypeOption = rangeChoiceType.clone();
                const categoryChoiceTypeOption = categoryChoiceType.clone();
                const sizeChoiceTypeOption = sizeChoiceType.clone();

                rangeChoiceType.find('option').not(':first').remove();
                categoryChoiceType.find('option').not(':first').remove();
                sizeChoiceType.find('option').not(':first').remove();

                heelTypeSelectBox.hide();
                heelHeightSelectBox.hide();
                closingSelectBox.hide();
                typeShapeSelectBox.hide();
                calfWidthSelectBox.hide();
                ceremonyCheckBoxType.hide();

                categoryChoiceType.attr('disabled', 'disabled');
                sizeChoiceType.attr('disabled', 'disabled');

                if (genderChoiceType.val()) {
                    onGenderOptionChange(genderChoiceType.val());

                    const selectedRangeOption = getSelectedRangeOption().val();
                    const selectedCategoryOption = getSelectedCategoryOption().val();
                    const selectedSizeOption = getSelectedSizeOption().val();

                    if (selectedRangeOption) {
                        sizeChoiceType.removeAttr('disabled');
                        onRangeOptionChange(selectedRangeOption);
                        rangeChoiceType
                            .find('option[value=\'' + selectedRangeOption + '\']')
                            .attr('selected', 'selected');

                        if (selectedCategoryOption) {
                            categoryChoiceType.removeAttr('disabled');
                            categoryChoiceType
                                .find('option[value=\'' + selectedCategoryOption + '\']')
                                .attr('selected', 'selected');
                        }

                        if (selectedSizeOption) {
                            sizeChoiceType
                                .find('option[value=\'' + selectedSizeOption + '\']')
                                .attr('selected', 'selected');
                        }
                    }
                }

                genderChoiceType.on('change', function (e) {
                    onGenderOptionChange($(this).val());
                });

                rangeChoiceType.on('change', function (e) {
                    onRangeOptionChange($(this).val());
                });

                function onGenderOptionChange(selectedValue) {
                    const options = getRangeOptions(selectedValue);

                    categoryChoiceType.attr('disabled', 'disabled');
                    sizeChoiceType.attr('disabled', 'disabled');

                    rangeChoiceType.find('option').not(':first').remove();
                    categoryChoiceType.find('option').not(':first').remove();
                    sizeChoiceType.find('option').not(':first').remove();

                    heelTypeSelectBox.hide();
                    heelHeightSelectBox.hide();
                    closingSelectBox.hide();
                    typeShapeSelectBox.hide();
                    calfWidthSelectBox.hide();
                    ceremonyCheckBoxType.hide();

                    rangeChoiceType.append(options);
                    rangeChoiceType.select2('destroy');
                    rangeChoiceType.select2({language: 'fr'});
                }

                function onRangeOptionChange(selectedValue) {
                    const categoryOptions = getCategoryOptions(selectedValue);
                    const sizeOptions = getSizeOptions(selectedValue);
                    const currentOption = getCurrentRangeOption(selectedValue);
                    const attributes = getAttributesByCurrentRangeOption(currentOption);

                    heelTypeSelectBox.hide();
                    heelHeightSelectBox.hide();
                    closingSelectBox.hide();
                    typeShapeSelectBox.hide();
                    calfWidthSelectBox.hide();
                    ceremonyCheckBoxType.hide();

                    categoryChoiceType.find('option').not(':first').remove();
                    sizeChoiceType.find('option').not(':first').remove();

                    categoryChoiceType.append(categoryOptions);
                    sizeChoiceType.append(sizeOptions);
                    categoryChoiceType.select2('destroy');
                    categoryChoiceType.select2({language: 'fr'});
                    sizeChoiceType.select2('destroy');
                    sizeChoiceType.select2({language: 'fr'});

                    toggleCategoryAndSize(selectedValue, categoryOptions);

                    if (attributes) {
                        toggleAttributes(attributes);
                    }
                }

                function getSelectedRangeOption() {
                    return rangeChoiceTypeOption
                        .find('option:selected')
                        .clone();
                }

                function getSelectedCategoryOption() {
                    return categoryChoiceTypeOption
                        .find('option:selected')
                        .clone();
                }

                function getSelectedSizeOption() {
                    return sizeChoiceTypeOption
                        .find('option:selected')
                        .clone();
                }

                function getRangeOptions(selectedValue) {
                    return rangeChoiceTypeOption
                        .find('option[data-gender=\'' + selectedValue + '\']')
                        .clone();
                }

                function getCategoryOptions(selectedValue) {
                    return categoryChoiceTypeOption
                        .find('option')
                        .not(':first')
                        .filter(function (index) {
                            return this.getAttribute('data-range')
                                && ($.inArray(selectedValue, this.getAttribute('data-range').split(','))) !== -1;
                        })
                        .clone();
                }

                function getSizeOptions(selectedValue) {
                    return sizeChoiceTypeOption
                        .find('option')
                        .not(':first')
                        .filter(function (index) {
                            return this.getAttribute('data-range')
                                && ($.inArray(selectedValue, this.getAttribute('data-range').split(','))) !== -1;
                        })
                        .clone();
                }

                function getCurrentRangeOption(selectedValue) {
                    return rangeChoiceTypeOption
                        .find('option')
                        .not(':first')
                        .filter(function (index) {
                            return this.value === selectedValue;
                        });
                }

                function getAttributesByCurrentRangeOption(currentOption) {
                    return currentOption.data('attributes')
                        ? currentOption.data('attributes').split(',')
                        : '';
                }

                function toggleCategoryAndSize(rangeSelectedValue, categoryOptions) {
                    if (rangeSelectedValue.length === 0) {
                        categoryChoiceType.attr('disabled', 'disabled');
                        sizeChoiceType.attr('disabled', 'disabled');
                    } else {
                        if (categoryOptions.length === 0) {
                            categoryChoiceType.attr('disabled', 'disabled');
                        } else {
                            categoryChoiceType.removeAttr('disabled');
                        }

                        sizeChoiceType.removeAttr('disabled');
                    }
                }

                function toggleAttributes(attributes) {
                    attributes.forEach(function (attribute, index, arr) {
                        if (attribute === 'ceremony') {
                            $('#p2s_new_item_' + attribute).show();
                        } else {
                            $('#' + attribute + 'SelectBox').show();
                        }
                    });
                }

                function matchStart(params, data) {
                    if ($.trim(params.term) === '') {
                        return data;
                    }

                    if (typeof data.text === 'undefined') {
                        return null;
                    }

                    if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) > -1) {
                        return $.extend({}, data, true);
                    }

                    return null;
                }

                function brandMatcher(params, data) {
                    if ($.trim(params.term) === '') {
                        return data;
                    }

                    if (typeof data.text === 'undefined') {
                        return null;
                    }

                    if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) > -1) {
                        return $.extend({}, data, true);
                    }

                    return data.text === 'Autre' ? data : null;
                }
            },
            methods: {
                showSize: function (e) {
                    const $this = e.target;
                    const $size = $('#js-size');
                    if ($this) {
                        try {
                            const value = $this.options[$this.selectedIndex].text;
                            return $size.text(value);
                        } catch (error) {
                        }
                    }
                },
                showBrand: function (e) {
                    const $this = e.target;
                    const $brand = $('#js-brand');
                    if ($this) {
                        try {
                            const value = $this.options[$this.selectedIndex].text;
                            return $brand.text(value);
                        } catch (error) {
                        }
                    }
                },
                showCondition: function (e) {
                    const $this = e.target;
                    const $condition = $('#js-condition');
                    if ($this) {
                        const value = $($this)
                            .closest('li')
                            .find('h3')
                            .text();
                        return $condition.html(value);
                    }
                },
                formatMoney(number, withVoucher = false) {
                    const money = withVoucher ? parseFloat((number.replace(',', '.') * 1.05).toFixed(3)) : parseFloat(number.replace(',', '.')).toFixed(2);
                    const isDecimal = isFinite(money);
                    return (isDecimal) ? money.toString().replace('.', ',') : number;
                },
            },
        });

        initStepMagellan();

        initStepSticky();

        const $form = $('#js-sale-form');
        const btnPublish = $('#btnPublish');
        const createProductForm = $('form[name=\'p2s_new_item\']');
        const editProductForm = $('form[name=\'p2s_edit_item\']');
        const isCertifiedItem = (createProductForm.length > 0 && createProductForm.hasClass('new-certified-product-form'))
            || (editProductForm.length > 0 && editProductForm.hasClass('edit-certified-product-form'));

        if (editProductForm.length && isCertifiedItem) {
            $('.js-vue-description').on('change', function (e) {
                checkStepValidation($form);
            });
        }

        btnPublish.on('click', function (e) {
            this.disabled = true;
            $('.hidden-publish-btn').val('true');
            $form.trigger('submit');
        });

        // first test
        checkStepValidation($form);

        $form.on('change', function (event) {
            checkStepValidation($(event.target));
        });

        $form.on('keyup', function (event) {
            checkStepValidation($(event.target));
        });

        $form.on('submit', function (e) {
            $('.js-remuneration').removeAttr('disabled');
            $('input.js-vue-price').val($('input.js-vue-price').val().replace(' ', '').replace('€', ''));
        });

        $($buttonStepNext).on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('js-step-end')) {
                this.disabled = true;
                if (!isCertifiedItem) {
                    e.stopImmediatePropagation();
                }

                if ($(this).hasClass('button-edit-certified')) {
                    $('.hidden-publish-btn').val('false');
                }

                if ($(this).attr('id') === 'btnCreate') {
                    $('.hidden-publish-btn').val('false');
                }

                $form.trigger('submit');
            } else {
                goToNextStep($(this));
            }
        });

        if ($stepCounterEdit.length) {
            $stepCounterEdit.children('ol').children('li').on('click', function () {
                openNextStep($(this).children('a').attr('href'));
            });
        }
    }

    if ($('.js-select2-unit-return-reason').length) {
        $('.js-select2-unit-return-reason').select2({language: 'fr'});

        $('.js-select2-unit-return-reason').on('change', function (e) {
            const selectedValue = $(this).val();
            if (selectedValue === 'other') {
                $('.js-unit-return-reason-description-label').removeClass('is-hidden');
                $('.js-unit-return-reason-description').removeClass('is-hidden').attr('required', true);
            } else {
                $('.js-unit-return-reason-description-label').addClass('is-hidden');
                $('.js-unit-return-reason-description').addClass('is-hidden').attr('required', false);
            }
        });
    }


    /*
     Moderate Item
     ===================================== */
    // if ($formProcessModeration.length) {
    //   initModerationSubmission();
    // }

    /*
     Search
     ===================================== */

    if ($searchForm) {
        // couldn't find a cleaner way to override message ...
        $.fn.select2.defaults.set('language', {
            errorLoading: function () {
                return 'Les résultats ne peuvent pas être chargés.';
            },
            inputTooLong: function (e) {
                var t = e.input.length - e.maximum,
                    n = 'Supprimez ' + t + ' caractère';
                return t !== 1 && (n += 's'), n;
            },
            inputTooShort: function (e) {
                var t = e.minimum - e.input.length,
                    n = 'Saisissez ' + t + ' caractère';
                return t !== 1 && (n += 's'), n;
            },
            loadingMore: function () {
                return 'Chargement de résultats supplémentaires…';
            },
            maximumSelected: function (e) {
                var t = 'Vous pouvez sélectionner jusqu\'à ' + e.maximum + ' magasin';
                return e.maximum !== 1 && (t += 's'), t;
            },
            noResults: function () {
                return 'Aucun résultat trouvé';
            },
            searching: function () {
                return 'Recherche en cours…';
            },
        });
    }

    const headerSearchBtnWrapper = $('.header-search-wrapper');
    const headerSearchBtn = $('#headerSearchBtn');
    const searchFilterResult = $('#js-search-filter-result');
    const btnFiltersMobile = $('#btnFiltersMobile');
    if (headerSearchBtn.length && searchFilterResult.length && btnFiltersMobile.length) {
        if (searchFilterResult.hasClass('is-open')) {
            headerSearchBtnWrapper.removeClass('is-hidden');
        }

        btnFiltersMobile.on('click', function (e) {
            e.preventDefault();
            if (searchFilterResult.hasClass('is-open')) {
                headerSearchBtnWrapper.addClass('is-hidden');
            } else {
                headerSearchBtnWrapper.removeClass('is-hidden');
            }
        });

        headerSearchBtn.on('click', function (e) {
            e.preventDefault();
            searchFilterResult.removeClass('is-open');
            $(this).parent().addClass('is-hidden');
        });
    }

    /* ===========================================================================
    Open tabs with anchor
    =========================================================================== */

    function openTabsAnchor() {
        if (!$('#how-to-sell').length) {
            return;
        }

        if (document.location.search === '?tab=dressing') {
            $('#tab-dressing').trigger('click');
        } else if (document.location.search === '?tab=store') {
            $('#tab-store').trigger('click');
        }
    }

    openTabsAnchor();

    // Init ajax callback message
    initAjaxCallbackMessage();

    // Browser class
    initBrowserClass();

    if ($aside) {
        /*
       Sticky
       ===================================== */

        sticky();
    }

    $('[data-scroll-to]').on('click', (event) => {
        const id = $(event.target).data('scroll-to');
        const $target = $(`#${id}`);

        if (!$target.length) {
            return;
        }

        const offSetTop = 70;
        const scrollTop = $target.offset().top - offSetTop;
        const duration = 1000;

        $('html, body').animate({scrollTop}, duration);
    });

    /*
     Offcanvas fixed
     ===================================== */

    if (!Foundation.MediaQuery.atLeast('xlarge')) {
        offCanvasFixed();
    }

    const $offcanvasCart = $('#js-off-canvas-cart');
    const $offcanvasCartBtn = $('.js-cart-count-container');
    const $offcanvasNav = $('#js-off-canvas');
    const $offcanvasNavBtn = $('#button-menu');
    const $searchForm = $('.search-form');
    const $offcanvasOverlay = $('.js-off-canvas-overlay');

    $('#js-open-search-bar').on('click', (event) => {
        closeOffCanvas($offcanvasCartBtn, $offcanvasCart);
        closeOffCanvas($offcanvasNavBtn, $offcanvasNav);
        $('.search-wrapper').addClass(activeClass);
    });

    $offcanvasNavBtn.on('click', (event) => {
        closeOffCanvas($offcanvasCartBtn, $offcanvasCart);
        closeSearchForm();
    });

    $offcanvasCartBtn.on('click', (event) => {
        closeOffCanvas($offcanvasNavBtn, $offcanvasNav);
        closeSearchForm();
    });

    function closeOffCanvas(clickElement, openedElement) {
        if (openedElement.hasClass('is-open')) {
            $offcanvasOverlay.removeClass('is-visible is-closable');
            openedElement.removeClass('is-open');
            clickElement.attr('aria-expanded', 'false');
        }
    }

    function closeSearchForm() {
        if ($searchForm.hasClass('is-active')) {
            $searchForm.removeClass('is-active');
            $searchForm.attr('aria-expanded', 'false');
            $('.search-wrapper').removeClass(activeClass);
        }
    }


    /*
     Upload
     ===================================== */

    const sortImages = () => {
        $(function () {
            let startIndex, endIndex, startEl, endEl, startInput, startText, startLabel, pendingEl, pendingInput,
                pendingLabel, pendingText, endInput, endText, endLabel;
            const $photosList = $('.js-upload-photo.upload-file-list');
            $photosList.sortable({
                start: function (event, ui) {
                    startIndex = ui.item.index();
                },
                stop: function (event, ui) {
                    endIndex = ui.item.index();

                    if (endIndex === 0) {
                        startIndex = 1;

                        startEl = $photosList.find('.js-upload-container').eq(startIndex);
                        startInput = startEl.find('input[type=file]');
                        startText = startEl.find('label.small-vertical');
                        startLabel = startEl.find('.upload-file-label');

                        endEl = $photosList.find('.js-upload-container').eq(ui.item.index()); // element à remplacer
                        endInput = endEl.find('input[type=file]');
                        endText = endEl.find('label.small-vertical');
                        endLabel = endEl.find('.upload-file-label');

                        pendingEl = endEl.clone();
                        pendingInput = endInput.clone();
                        pendingText = endText.clone();
                        pendingLabel = endLabel.clone();

                        endInput.attr('id', startInput.attr('id'));
                        endInput.attr('name', startInput.attr('name'));
                        endInput.attr('files', startInput.attr('files'));
                        endInput.attr('class', startInput.attr('class'));
                        endLabel.attr('for', startLabel.attr('for'));

                        endInput.attr('data-is-already-uploaded-image', startInput.attr('data-is-already-uploaded-image'));
                        endText.text(startText.text());
                        showPreviewFile(endInput[0]).catch(() => clearInput(endInput[0]));

                        startInput.attr('id', pendingInput.attr('id'));
                        startInput.attr('name', pendingInput.attr('name'));
                        startInput.attr('files', pendingInput.attr('files'));
                        startInput.attr('class', pendingInput.attr('class'));
                        showPreviewFile(startInput[0]).catch(() => clearInput(startInput[0]));

                        startInput.attr('data-is-already-uploaded-image', pendingInput.attr('data-is-already-uploaded-image'));
                        startText.text(pendingText.text());
                        startLabel.attr('for', pendingLabel.attr('for'));
                        document.querySelectorAll('.js-upload-photo.upload-file-list li').forEach((elem, index) => {
                            elem.setAttribute('data-index', index + 1);
                        });
                        uploadManagement();
                        $('.js-item-selected-image canvas').hide();
                        $('#js-imagePrimary').attr('src', endEl.find('img').attr('src'));
                    }
                },
            });
        });
    };

    const uploadManagement = () => {
        const $mainUploadPhoto = document.querySelector('#js-upload-photo-main');
        const $uploadPhoto = document.querySelector('.js-upload-photo');
        const $dragAndDropWrapper = document.querySelector('.custom-file-wrapper');

        if ($uploadPhoto && $mainUploadPhoto) {
            $uploadPhoto.addEventListener('change', function (e) {
                const $this = e.target;

                // In edit mode, there is checkbox to specify if user need to delete a picture, and the checkbox is embedded
                // in "ul.js-upload-photo" element (stepPhotos.html.twig). So we have to check if we are here for an upload or not.
                if (!$this.classList.contains('js-edit-delete-picture')) {
                    showPreviewFile($this).catch(() => clearInput($this));
                }
                //removePreviewFile($this);
            });

            $dragAndDropWrapper.addEventListener('drop', (e) => {
                e.preventDefault();
                const customFileLabel = document.querySelector('.custom-file-label');
                const eventFiles = e.dataTransfer.files;
                const uploadedFilesLength = eventFiles.length;
                const hasImageTooBig = [...eventFiles].some(file => file.size > 4000000);
                customFileLabel.classList.remove('disabled-label');
                $mainUploadPhoto.removeAttribute('disabled');
                if (hasImageTooBig) {
                    document.getElementById('big-photos').classList.remove('is-hidden');
                    return;
                }
                if (uploadedFilesLength > 5) {
                    document.getElementById('max-photos').classList.remove('is-hidden');
                    return;
                } else {
                    $uploadPhoto.classList.remove('is-hidden');
                    sortImages();
                    if (uploadedFilesLength === 5) {
                        customFileLabel.classList.add('disabled-label');
                        $mainUploadPhoto.setAttribute('disabled', true);
                    }
                    document.querySelectorAll('.error-message').forEach(message => message.classList.add('is-hidden'));
                    for (let i = 0; i < uploadedFilesLength; i++) {
                        const dataTransfer = new DataTransfer();
                        dataTransfer.items.add(e.dataTransfer.files[i]);
                        let copyNumber = i;
                        const targetId = copyNumber + 1;
                        const $targetInput = $uploadPhoto.querySelector(`li:nth-child(${targetId})`).querySelector('input');
                        $targetInput.files = dataTransfer.files;
                        showPreviewFile($targetInput).catch(() => clearInput($targetInput));
                    }
                }
            });

            $dragAndDropWrapper.addEventListener('dragover', (e) => {
                e.preventDefault();
            });

            $mainUploadPhoto.addEventListener('change', (e) => {
                const customFileLabel = document.querySelector('.custom-file-label');
                const eventFiles = e.target.files;
                const uploadedFilesLength = eventFiles.length;
                const hasImageTooBig = [...eventFiles].some(file => file.size > 4000000);
                customFileLabel.classList.remove('disabled-label');
                $mainUploadPhoto.removeAttribute('disabled');
                if (hasImageTooBig) {
                    document.getElementById('big-photos').classList.remove('is-hidden');
                    return;
                }
                if (uploadedFilesLength > 5) {
                    document.getElementById('max-photos').classList.remove('is-hidden');
                    return;
                } else {
                    $uploadPhoto.classList.remove('is-hidden');
                    sortImages();
                    if (uploadedFilesLength === 5) {
                        customFileLabel.classList.add('disabled-label');
                        $mainUploadPhoto.setAttribute('disabled', true);
                    }
                    document.querySelectorAll('.error-message').forEach(message => message.classList.add('is-hidden'));
                    for (let i = 0; i < uploadedFilesLength; i++) {
                        const dataTransfer = new DataTransfer();
                        dataTransfer.items.add(e.target.files[i]);
                        let copyNumber = i;
                        const targetId = copyNumber + 1;
                        const $targetInput = $uploadPhoto.querySelector(`li:nth-child(${targetId})`).querySelector('input');
                        $targetInput.files = dataTransfer.files;
                        showPreviewFile($targetInput).catch(() => clearInput($targetInput));
                    }
                }
            });

            $uploadPhoto.addEventListener('click', function (e) {
                const $this = e.target;

                // Supression de l'image
                if ($this && $this.matches('.js-remove-file')) {
                    removePreviewFile($this);
                    checkStepValidation($this);
                    document.querySelector('.custom-file-label').classList.remove('disabled-label');
                    document.getElementById('js-upload-photo-main').removeAttribute('disabled');
                } else {
                    return;
                }
            });
        }
    };

    uploadManagement();

    topBanner();

    /* ===========================================================================
   Scroll
   =========================================================================== */

    const $header = document.getElementById('js-header');

    window.addEventListener('scroll', function (e) {
        const scrollTop = this.pageYOffset || this.scrollY;

        if (scrollTop > 100) {
            $header.classList.add(srollingClass);
        } else {
            $header.classList.remove(srollingClass);
        }
    });


    const btnCloseNotification = document.getElementById('btnCloseNews');
    const notificationSection = document.getElementById('homepageNews');

    if (btnCloseNotification && notificationSection) {
        btnCloseNotification.addEventListener('click', function (e) {
            notificationSection.style.display = 'none';
        });
    }
});
